import React, { useState, useEffect } from "react";

import Section1 from "../component/home/Section1";
import Section2 from "../component/home/Section2";
import Section3 from "../component/home/Section3";
import Section4 from "../component/home/Section4";
import News from "../component/home/News";
import IsuTerkini from "../component/home/IsuTerkini";
import OpiniHome from "../component/home/OpiniHome";
import Section6 from "../component/home/Section6";
import Section7 from "../component/home/Section7";
import Section8 from "../component/home/Section8";
import Section9 from "../component/home/Section9";
import Section11 from "../component/home/Section11";
import Section15 from "../component/home/Section15";
import Swal from "sweetalert2";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const [isPopupActive, setPopupActive] = useState(true);
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  // [BARU] State untuk mendeteksi apakah banner sedang di-hover/klik
  const [isPaused, setIsPaused] = useState(false);

  // Handler untuk menutup popup
  const handleClose = () => {
    setPopupActive(false);
  };

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  const convertToSlug = (title) => {
    if (!title) return "";
    return title
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const url = process.env.REACT_APP_API_URL;
        const response = await axios.get(`${url}/welcome_pages`);
        setPost(response.data);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchMenu();
  }, []);

  useEffect(() => {
    // [MODIFIKASI] Tambahkan kondisi !isPaused agar interval tidak berjalan saat di-hover
    if (post?.length > 1 && isPopupActive && !isPaused) {
      const interval = setInterval(() => {
        setCurrentBannerIndex((prev) => (prev + 1) % post.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [post, isPopupActive, isPaused]); // [MODIFIKASI] Tambahkan isPaused sebagai dependency

  return (
    <div className="page-wrapper">
      <Section1 />
      <Section3 />
      <Section2 />
      <Section9 />
      <News />
      <Section7 />
      <OpiniHome />
      <Section4 />
      <Section8 />
      <Section6 />
      <Section11 />

      {isPopupActive && (
        <div className={`information-popup ${isPopupActive ? "active" : ""}`}>
          <div
            className="information-popup-overlay search-toggler-x"
            onClick={handleClose}
          ></div>
          <div
            className="information-popup-content"
            style={{ background: "transparent", padding: 0, boxShadow: "none" }}
          >
            {loading ? (
              <div className="skeleton-kdeks skeleton-kdeks-img"></div>
            ) : (
              <>
                <style>
                  {`
                    @keyframes popupFade {
                      0% { opacity: 0; transform: scale(0.95); }
                      100% { opacity: 1; transform: scale(1); }
                    }
                  `}
                </style>
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ width: "100%", height: "100%" }}
                >
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                    // [BARU] Event handler untuk mendeteksi hover dan klik (desktop & mobile)
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    onTouchStart={() => setIsPaused(true)}
                    onTouchEnd={() => setIsPaused(false)}
                  >
                    <button
                      type="button"
                      className="btn-close bg-white rounded-circle shadow"
                      aria-label="Close"
                      onClick={handleClose}
                      style={{
                        position: "absolute",
                        top: "-15px",
                        right: "-15px",
                        zIndex: 105,
                        padding: "10px",
                        opacity: 1,
                        cursor: "pointer",
                      }}
                    ></button>

                    {post?.length > 0 && (
                      <img
                        key={currentBannerIndex}
                        className="img-fluid shadow-lg"
                        src={post[currentBannerIndex]?.path}
                        alt={`Iklan ${currentBannerIndex + 1}`}
                        style={{
                          borderRadius: "15px",
                          maxHeight: "80vh",
                          maxWidth: "90vw",
                          objectFit: "contain",
                          animation: "popupFade 0.8s ease-out forwards",
                          display: "block",
                        }}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;